import React, { FC, RefObject, useState } from 'react';
import { useReactToPrint } from 'react-to-print';

import ButtonDownload from 'shared/components/Buttons/ButtonDownload';
import ButtonPrint from 'shared/components/Buttons/ButtonPrint';
import { SnackbarError, SnackbarSuccess } from 'shared/components/_Snackbars';

import { ADMIN_SEARCH_FILTER_TYPE, ISearchOpportunitiesSort } from '@joc/api-gateway/lib/api-client';

import { SuperAdminOpportunitiesFilters } from './mappers';
import { useExportSuperAdminOpportunities } from './hooks/useExportSuperAdminOpportunities';

type SuperAdminOpportunitiesActionsNewProps = {
	printRef: RefObject<HTMLDivElement>;
	setIsPrintableTable: React.Dispatch<React.SetStateAction<boolean>>;
	opportunityFilterType: ADMIN_SEARCH_FILTER_TYPE;
	search?: string;
	sort?: ISearchOpportunitiesSort;
	filters?: SuperAdminOpportunitiesFilters;
	disabled?: boolean;
};

const SuperAdminOpportunitiesActionsNew: FC<SuperAdminOpportunitiesActionsNewProps> = ({
	printRef,
	setIsPrintableTable,
	opportunityFilterType,
	search,
	sort,
	filters,
	disabled,
}: SuperAdminOpportunitiesActionsNewProps) => {
	const [isReportGenerationSnackbarOpen, setIsReportGenerationSnackbarOpen] = useState(false);
	const [isReportErrorSnackbarOpen, setIsReportErrorSnackbarOpen] = useState(false);

	const exportMutation = useExportSuperAdminOpportunities({ opportunityFilterType, search, sort, filters });

	const handlePrint = useReactToPrint({
		onBeforeGetContent: () => setIsPrintableTable(true),
		onAfterPrint: () => setIsPrintableTable(false),
		content: () => printRef.current,
	});

	const buttonExportClickHandler = async () => {
		try {
			await exportMutation.mutateAsync();
			setIsReportGenerationSnackbarOpen(true);
		} catch (_error) {
			setIsReportErrorSnackbarOpen(true);
		}
	};

	return (
		<div style={{ display: 'flex' }}>
			<div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 12 }}>
				<ButtonDownload clickHandler={buttonExportClickHandler} disabled={disabled} />
				<ButtonPrint clickHandler={handlePrint} disabled={disabled} />
			</div>

			<SnackbarError
				open={isReportErrorSnackbarOpen}
				onClose={setIsReportErrorSnackbarOpen}
				message="Something went wrong. Please try again."
				width={320}
			/>
			<SnackbarSuccess
				open={isReportGenerationSnackbarOpen}
				onClose={setIsReportGenerationSnackbarOpen}
				message="Report is being generated. You will receive it by email."
				width={420}
			/>
		</div>
	);
};

export default SuperAdminOpportunitiesActionsNew;
